<template>
    <div
        class="tab-container"
    >
        <h1 class="tab-header">
            <div>{{ title }}</div>
        </h1>
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        }
    }
};
</script>

<style src="./common.tab.css" scoped></style>
<style lang="postcss" scoped>
@screen sm {
    .tab-container:not(:last-of-type) {
        @apply pb-32;
    }
}
</style>
